// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"542":"2161624a","960":"5d4fd1d7"}[chunkId] + ".css";
};